import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from "@mui/material";
import React, { useState } from "react";
import RejectReasonModal from "../../Modals/rejectReason";

import IosSwitch from "../../components/iosSwitch";
import SearchBar from "../../components/SearchBar";

const radioOptions = [
  {
    value: "year",
    label: (
      <div className="purchase_sub_bx">
        <p className="price">
          <img src="/static/images/subscription_icon.svg" alt="icon" />{" "}
          <ins>AED 8,000/</ins>
          <sub>Per year</sub>
        </p>
        <p>Ideal for those seeking uninterrupted, year-round access.</p>
      </div>
    ),
  },
  {
    value: "quarter",
    label: (
      <div className="purchase_sub_bx">
        <p className="price">
          <img src="/static/images/subscription_icon.svg" alt="icon" />{" "}
          <ins>AED 4,500/</ins>
          <sub>Semi-annual</sub>
        </p>
        <p>A flexible option to access full membership benefits.</p>
      </div>
    ),
  },
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ViewEmployee = () => {
  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <MainContainer>
        <div className="main_title">
          <h1 className="back_arrow">
            {" "}
            <IconButton onClick={() => goBack()}>
              {" "}
              <ArrowBackIcon />{" "}
            </IconButton>{" "}
            Employee Detail
          </h1>
        </div>

        <div className="cards view_page">
          <div className="profile_bx  mb_30">
            <div className="profile_dtl">
              <figure>
                <img src="/static/images/profile_img.png" alt="profile img" />
              </figure>
              <div className="profile_cnt">
                <h2>Abdul Kean</h2>
                <p>
                  {" "}
                  <a>
                    {" "}
                    <IconButton>
                      <img src="/static/images/email_icon.svg" alt="icon" />
                    </IconButton>{" "}
                    abdul@sample.com
                  </a>
                </p>
                <p>
                  {" "}
                  <a>
                    {" "}
                    <IconButton>
                      <img src="/static/images/call_icon.svg" alt="icon" />
                    </IconButton>{" "}
                    +971 (0) 567894623
                  </a>
                </p>
              </div>
            </div>
            <div className="rt">
              <IosSwitch />
              <Button className="btn btn_primary">
                {" "}
                <img src="/static/images/edit_icon.svg" alt="icon" /> Edit
                Details
              </Button>
            </div>
          </div>

          <div className="section_title">
            <h2>Membership Type</h2>
          </div>

          <div className="gap_p ">
            <div className="w_25">
              <h6>Birthday</h6>
              <p>20 July, 2000</p>
            </div>
            <div className="w_25">
              <h6>Gender</h6>
              <p>Female</p>
            </div>
          </div>
        </div>
      </MainContainer>

      <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />
    </>
  );
};

export default ViewEmployee;
